// Banery serwisu nad każdym ekranem (docs/pwa/SERWIS.md) - dane dla banerów powłoki: klient - prośba serwisu czeka
// na odpowiedź (push przychodzi tylko raz), prośba o podgląd ekranu czeka albo ekran jest udostępniany („Zakończ”
// w każdej chwili, na każdym ekranie APP); admin - lista urządzeń pokazuje sztuki klienta („Wyjdź” wraca do własnych).
import { useEffect, useSyncExternalStore } from "react";
import { useLocation, useNavigate } from "react-router";
import { t } from "../../i18n/t";
import { useSerwis, zakonczEkran } from "../../api/serwis";
import { udostepnijEkran } from "../../brama/ekran";
import { biezacyKlient, subskrybujKlienta, ustawKlientaAdmina } from "../../brama/polaczenie";
import { IkonaOko, IkonaSerwis } from "../../uklad/ikony";
import type { BanerDane } from "../../uklad/Powloka";
import { kto } from "./opis";

export function useBaneryserwisu(): BanerDane[] {
  const s = useSerwis();
  const klient = useSyncExternalStore(subskrybujKlienta, biezacyKlient);
  const { pathname } = useLocation();
  const idz = useNavigate();
  const prosby = s?.dostepy.filter((g) => g.stan === "prosba").length ?? 0;
  const mojeEkrany = s?.ekrany.filter((e) => !e.ogladam) ?? [];
  const prosbaEkranu = mojeEkrany.find((e) => e.stan === "prosba");
  const udostepniany = mojeEkrany.find((e) => e.stan === "aktywna");
  // Nagrywanie trwa, póki trwa sesja - na każdym ekranie APP, nie tylko w Serwisie.
  const sesja = udostepniany?.id;
  useEffect(() => (sesja === undefined ? undefined : udostepnijEkran(sesja)), [sesja]);
  const out: BanerDane[] = [];
  if (klient) {
    out.push({ id: "klient", rodzaj: "info", ikona: IkonaOko, tresc: t("Przeglądasz urządzenia klienta {k}.", { k: klient.nazwa }),
      etykietaAkcji: t("Wyjdź"), onAkcja: () => ustawKlientaAdmina(null) });
  }
  if (udostepniany) {
    out.push({ id: "ekran", rodzaj: "uwaga", ikona: IkonaOko, tresc: t("Udostępniasz ekran - {kto} widzi aplikację i może w niej klikać.", { kto: kto(udostepniany) }),
      etykietaAkcji: t("Zakończ"), onAkcja: () => void zakonczEkran(udostepniany.id).catch(() => undefined) });
  }
  if (prosbaEkranu && pathname !== "/serwis") {
    out.push({ id: "ekran-prosba", rodzaj: "uwaga", ikona: IkonaOko, tresc: t("{kto} prosi o podgląd Twojego ekranu, żeby pomóc.", { kto: kto(prosbaEkranu) }),
      etykietaAkcji: t("Odpowiedz"), onAkcja: () => void idz("/serwis") });
  }
  if (prosby > 0 && pathname !== "/serwis") {
    out.push({ id: "serwis", rodzaj: "uwaga", ikona: IkonaSerwis, tresc: t("Serwis prosi o dostęp do Twoich urządzeń."),
      etykietaAkcji: t("Odpowiedz"), onAkcja: () => void idz("/serwis") });
  }
  return out;
}
